import { createContext, useContext } from 'react';
import noop from 'utils/noop';

type SearchContextType = {
  debouncedValue: string;
  inputValue: string;
  setInputValue: (val: string) => void;
};

const defaultState = {
  debouncedValue: '',
  inputValue: '',
  setInputValue: noop,
};

export const SearchContext = createContext<SearchContextType>(defaultState);

export const useSearchContext = () => useContext<SearchContextType>(SearchContext);
